import { defineMessages } from "react-intl";

export const messages = defineMessages({
  step01: {
    id: "guides.acaActiveDealers.tour.step01",
    defaultMessage: "Open the Map",
    description: "ACA active-dealers tour, step 1 (open map) title",
  },
  step01Description: {
    id: "guides.acaActiveDealers.tour.step01.description",
    defaultMessage: "Let’s open the Map to get started — click here.",
    description: "ACA active-dealers tour, step 1 (open map) message",
  },
  step02: {
    id: "guides.acaActiveDealers.tour.step02",
    defaultMessage: "Show only Companies",
    description: "ACA active-dealers tour, step 2 (companies-only visibility) title",
  },
  step02Description: {
    id: "guides.acaActiveDealers.tour.step02.description",
    defaultMessage:
      "Let’s focus on companies. Click the icons to hide People and Deals, leaving only Companies visible. Once only Companies show, click Next.",
    description: "ACA active-dealers tour, step 2 (companies-only visibility) message",
  },
  step03: {
    id: "guides.acaActiveDealers.tour.step03",
    defaultMessage: "Add filters",
    description: "ACA active-dealers tour, step 3 (open filter) title",
  },
  step03Description: {
    id: "guides.acaActiveDealers.tour.step03.description",
    defaultMessage: "Now let’s add some filters. Click Filter to start.",
    description: "ACA active-dealers tour, step 3 (open filter) message",
  },
  step04: {
    id: "guides.acaActiveDealers.tour.step04",
    defaultMessage: "Choose a record type",
    description: "ACA active-dealers tour, step 4 (open filter-type menu) title",
  },
  step04Description: {
    id: "guides.acaActiveDealers.tour.step04.description",
    defaultMessage: "Click here to choose which record type to filter.",
    description: "ACA active-dealers tour, step 4 (open filter-type menu) message",
  },
  step05: {
    id: "guides.acaActiveDealers.tour.step05",
    defaultMessage: "Company filters",
    description: "ACA active-dealers tour, step 5 (choose Company type) title",
  },
  step05Description: {
    id: "guides.acaActiveDealers.tour.step05.description",
    defaultMessage: "Click “Company” to add a company filter.",
    description: "ACA active-dealers tour, step 5 (choose Company type) message",
  },
  step06: {
    id: "guides.acaActiveDealers.tour.step06",
    defaultMessage: "Pick a field",
    description: "ACA active-dealers tour, step 6 (select Owner field) title",
  },
  step06Description: {
    id: "guides.acaActiveDealers.tour.step06.description",
    defaultMessage:
      "Open this dropdown and choose the “Owner” field. Tip: type to filter the list.",
    description: "ACA active-dealers tour, step 6 (select Owner field) message",
  },
  step07: {
    id: "guides.acaActiveDealers.tour.step07",
    defaultMessage: "Choose yourself",
    description: "ACA active-dealers tour, step 7 (select self as owner) title",
  },
  step07Description: {
    id: "guides.acaActiveDealers.tour.step07.description",
    defaultMessage:
      "Select yourself as the owner — just you, no one else. Next unlocks once you’re the only one chosen.",
    description: "ACA active-dealers tour, step 7 (select self as owner) message",
  },
  step08: {
    id: "guides.acaActiveDealers.tour.step08",
    defaultMessage: "Add another filter",
    description: "ACA active-dealers tour, step 8 (add filter rule) title",
  },
  step08Description: {
    id: "guides.acaActiveDealers.tour.step08.description",
    defaultMessage: "Let’s narrow it down. Click “Add filter rule”.",
    description: "ACA active-dealers tour, step 8 (add filter rule) message",
  },
  step09: {
    id: "guides.acaActiveDealers.tour.step09",
    defaultMessage: "Pick a field",
    description: "ACA active-dealers tour, step 9 (select posstatus field) title",
  },
  step09Description: {
    id: "guides.acaActiveDealers.tour.step09.description",
    defaultMessage: "In the new row, open the field dropdown and choose “posstatus”.",
    description: "ACA active-dealers tour, step 9 (select posstatus field) message",
  },
  step10: {
    id: "guides.acaActiveDealers.tour.step10",
    defaultMessage: "Choose Active",
    description: "ACA active-dealers tour, step 10 (select Active value) title",
  },
  step10Description: {
    id: "guides.acaActiveDealers.tour.step10.description",
    defaultMessage:
      "Select “Active” as the value — just that one. Next unlocks once “Active” is your only choice.",
    description: "ACA active-dealers tour, step 10 (select Active value) message",
  },
  step11: {
    id: "guides.acaActiveDealers.tour.step11",
    defaultMessage: "Apply your filters",
    description: "ACA active-dealers tour, step 11 (close filter panel) title",
  },
  step11Description: {
    id: "guides.acaActiveDealers.tour.step11.description",
    defaultMessage:
      "That’s your filter: the active dealers you own. Click Next to close this panel.",
    description: "ACA active-dealers tour, step 11 (close filter panel) message",
  },
  step12: {
    id: "guides.acaActiveDealers.tour.step12",
    defaultMessage: "Zoom the map",
    description: "ACA active-dealers tour, step 12 (zoom controls) title",
  },
  step12Description: {
    id: "guides.acaActiveDealers.tour.step12.description",
    defaultMessage: "Use these buttons — or your mouse wheel — to zoom in and out.",
    description: "ACA active-dealers tour, step 12 (zoom controls) message",
  },
  step13: {
    id: "guides.acaActiveDealers.tour.step13",
    defaultMessage: "Open the list",
    description: "ACA active-dealers tour, step 13 (open record list) title",
  },
  step13Description: {
    id: "guides.acaActiveDealers.tour.step13.description",
    defaultMessage: "Click here to see the pins in view as a list.",
    description: "ACA active-dealers tour, step 13 (open record list) message",
  },
  step14: {
    id: "guides.acaActiveDealers.tour.step14",
    defaultMessage: "Your records",
    description: "ACA active-dealers tour, step 14 (record list) title",
  },
  step14Description: {
    id: "guides.acaActiveDealers.tour.step14.description",
    defaultMessage: "Here’s every store currently in view — your active dealers. You’re all set!",
    description: "ACA active-dealers tour, step 14 (record list) message",
  },
});

export const errorMessages = defineMessages({
  noPosStatusField: {
    id: "guides.acaActiveDealers.tour.error.noPosStatusField",
    defaultMessage:
      "This tour needs the “posstatus” company field, but your organization doesn’t have one.",
    description: "ACA active-dealers tour, error shown when the posstatus company field is missing",
  },
});
